<script setup lang="ts">
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Icon } from "@/model/icon";

defineProps<{ description: string; hint?: string; hintIcon?: Icon }>();
</script>

<template>
  <span class="section-info-tooltip">
    <BaseTooltip position="right" :max-width="400">
      <SvgIcon name="filled/info" width="16" height="16" />
      <template #content>
        <div class="section-info-tooltip-content">
          <p class="description">{{ description }}</p>
          <p v-if="hint" class="hint">
            <span v-if="hintIcon" class="hint-icon">
              <SvgIcon :name="hintIcon" width="16" height="16" />
            </span>
            {{ hint }}
          </p>
        </div>
      </template>
    </BaseTooltip>
  </span>
</template>

<style lang="scss">
@use "@/styles/variables/colors";

.section-info-tooltip {
  .base-tooltip {
    display: flex;
    align-items: center;
  }
}

.section-info-tooltip-content {
  padding: 8px 4px;

  .description {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  .hint {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 8px;
    background-color: colors.$palette-white-alpha-10;
    border-radius: 4px;

    .hint-icon {
      display: flex;
      padding: 2px;
      border: 1px solid colors.$palette-white-alpha-30;
      border-radius: 4px;
    }
  }
}
</style>
